import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withValue } from '@g4/automation-hooks';
import { useSSRQuery } from '../graphql';
import { Box, Text, Spinner } from './Boneyard';
import HOME_FORGOT_PASSWORD from '../../automationHooks';
import { useAuthentication } from '../graphql';
import FORGOT_PASSWORD_TRANSLATIONS_QUERY from './forgotPasswordWrapper/forgotPasswordTranslations.query.graphql.js';
import ForgotPassword from '@g4/next-furniture/ForgotPasswordForm/ForgotPassword';

const ContentWrapper = styled(Box)`
  display: flex;
  width: ${props => (props.isMobile ? 'inherit' : '500px')};
  height: auto;
`;

const SpinnerWrapper = styled(Box)`
  width: ${props => (props.isMobile ? 'inherit' : '500px')};
  height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ForgotPasswordTitle = () => {
  const { loading, error, data } = useSSRQuery(
    FORGOT_PASSWORD_TRANSLATIONS_QUERY
  );

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  const title = data?.application.translations.common.forgotPasswordTitle;

  return (
    <Text automationHook={withValue(HOME_FORGOT_PASSWORD.hook, 'title')}>
      {title}
    </Text>
  );
};

const ForgotPasswordWrapper = ({
  automationHook,
  isMobile,
  setContent,
  setTitle,
  unsetModal,
  setShowModal,
}) => {
  const { resetPassword } = useAuthentication();
  const { loading, error, data } = useSSRQuery(
    FORGOT_PASSWORD_TRANSLATIONS_QUERY
  );

  if (loading) {
    return (
      <SpinnerWrapper isMobile={isMobile}>
        <Spinner
          size="small"
          appearance="dark"
          automationHook={withValue(automationHook, 'loading-spinner')}
          inline
        />
      </SpinnerWrapper>
    );
  }

  if (error) {
    throw error;
  }
  const translations = data?.application.translations.common;

  return (
    <ContentWrapper isMobile={isMobile}>
      <Box d="flex" w="100%" direction={'column'}>
        <ForgotPassword
          translations={translations}
          isMobile={isMobile}
          automationHook={automationHook}
          resetPassword={resetPassword}
          setContent={setContent}
          setTitle={setTitle}
          unsetModal={unsetModal}
          setShowModal={setShowModal}
        />
      </Box>
    </ContentWrapper>
  );
};

ForgotPasswordWrapper.propTypes = {
  isMobile: PropTypes.bool,
  automationHook: PropTypes.object,
  setContent: PropTypes.func,
  setTitle: PropTypes.func,
  unsetModal: PropTypes.func,
  setShowModal: PropTypes.func,
};

export default ForgotPasswordWrapper;
